import { render, staticRenderFns } from "./PaperInvoicesView.vue?vue&type=template&id=31cdc05b"
import script from "./PaperInvoicesView.vue?vue&type=script&lang=ts"
export * from "./PaperInvoicesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports